import clsx from 'clsx'

const map: Record<string, string> = {
  approved: 'success',
  completed: 'success',
  paid: 'success',
  pending: 'warning',
  submitted: 'warning',
  revision: 'warning',
  rejected: 'danger',
  blocked: 'danger',
  disputed: 'danger',
  hidden: 'danger',
  cancelled: 'danger',
  none: '',
  customer: 'primary',
  executor: '',
}

export function StatusBadge({ value, label }: { value: string; label?: string }) {
  return <span className={clsx('badge', map[value] || '')}>{label || value}</span>
}
